import * as services from '../../../services/graphql/widgets/slim-banner-bottom-my-local-news';

import widget from './widget';

export default {
  ...widget,
  services,
  styles: {
    iconsColor: 'c-light',
  },
};
